export default {
  apiVersion: "v1",
  apiUrl: "https://stark-atoll-76091.herokuapp.com",
  apiUrl2: "https://stark-atoll-76091.herokuapp.com",
  imgUrl: "http://localhost:5000/clients/public/uploads/",
};
